import * as React from 'react';

export const Bordered: React.FC = ({ children }) => <div className="border rounded p-3">{children}</div>;
